var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarInput(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.721,
    height: 17.208,
    viewBox: "186.816 40.54 17.721 17.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2037",
    transform: "translate(186.816 40.54)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.643 17.208H3.079A3.082 3.082 0 0 1 0 14.129V4.14A3.083 3.083 0 0 1 3.079 1.06h11.564a3.082 3.082 0 0 1 3.079 3.079v9.99a3.081 3.081 0 0 1-3.08 3.079M3.08 2.292a1.85 1.85 0 0 0-1.847 1.847v9.99a1.85 1.85 0 0 0 1.847 1.847h11.564a1.85 1.85 0 0 0 1.847-1.847V4.14a1.85 1.85 0 0 0-1.847-1.847H3.079Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.65 4.96h16.421v1.232H.651V4.961z",
    fillRule: "evenodd",
    "data-name": "Rectangle 1527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94 3.284a.616.616 0 0 1-.616-.615V.616a.616.616 0 0 1 1.231 0v2.053c0 .34-.275.615-.615.615",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86 3.284a.616.616 0 0 1-.615-.615V.616a.616.616 0 0 1 1.232 0v2.053c0 .34-.276.615-.616.615",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.782 3.284a.616.616 0 0 1-.616-.615V.616a.616.616 0 0 1 1.232 0v2.053c0 .34-.276.615-.616.615",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.445 9.438H2.91a1.064 1.064 0 0 1 0-2.127h1.534a1.064 1.064 0 0 1 0 2.127M2.91 8.022a.353.353 0 0 0 0 .706h1.534a.352.352 0 1 0 0-.706H2.91Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.628 9.438H8.095A1.065 1.065 0 0 1 7.03 8.375c0-.586.478-1.064 1.064-1.064h1.533a1.064 1.064 0 0 1 0 2.127M8.095 8.022a.353.353 0 0 0 0 .706h1.533a.352.352 0 1 0 0-.706H8.095Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.811 9.438h-1.533a1.065 1.065 0 0 1-1.064-1.063c0-.586.478-1.064 1.064-1.064h1.533c.587 0 1.064.478 1.064 1.064 0 .587-.477 1.063-1.064 1.063m-1.533-1.416a.353.353 0 0 0 0 .706h1.533a.353.353 0 1 0 0-.706h-1.533Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.445 12.234H2.91a1.065 1.065 0 0 1 0-2.128h1.534a1.065 1.065 0 0 1 0 2.128M2.91 10.816a.354.354 0 0 0 0 .707h1.534a.353.353 0 0 0 0-.707H2.91Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.628 12.234H8.095A1.066 1.066 0 0 1 7.03 11.17c0-.586.478-1.064 1.064-1.064h1.533a1.065 1.065 0 0 1 0 2.128m-1.533-1.418a.354.354 0 0 0 0 .707h1.533a.353.353 0 0 0 0-.707H8.095Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.811 12.234h-1.533a1.066 1.066 0 0 1-1.064-1.064c0-.586.478-1.064 1.064-1.064h1.533c.587 0 1.064.478 1.064 1.064 0 .586-.477 1.064-1.064 1.064m-1.533-1.418a.354.354 0 0 0 0 .707h1.533a.354.354 0 0 0 0-.707h-1.533Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.445 15.027H2.91a1.064 1.064 0 0 1 0-2.127h1.534a1.064 1.064 0 0 1 0 2.127M2.91 13.61a.353.353 0 0 0 0 .705h1.534a.352.352 0 1 0 0-.705H2.91Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.628 15.027H8.095a1.065 1.065 0 0 1-1.064-1.063c0-.586.478-1.064 1.064-1.064h1.533a1.064 1.064 0 0 1 0 2.127M8.095 13.61a.353.353 0 0 0 0 .705h1.533a.352.352 0 1 0 0-.705H8.095Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.811 15.027h-1.533a1.065 1.065 0 0 1-1.064-1.063c0-.586.478-1.064 1.064-1.064h1.533c.587 0 1.064.478 1.064 1.064 0 .586-.477 1.063-1.064 1.063m-1.533-1.416a.353.353 0 0 0 0 .705h1.533a.353.353 0 1 0 0-.705h-1.533Z",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6795"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17.722v17.208H0V0z",
    "data-name": "Rectangle 1528"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarInput);
export default __webpack_public_path__ + "static/media/calendarInput.baef20c12a38e8aaf6b5e230ffb2419f.svg";
export { ForwardRef as ReactComponent };